'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var NewRoleService = function NewRoleService(Restangular, RsqlQuery, $q, $log) {
  var serviceRoles = Restangular.one('configuration');
  var userRoles = Restangular.one('users');
  function getRole(roleName) {
    var rsqlQuery = new RsqlQuery();
    var query = rsqlQuery.is('role').equalTo(roleName).query();
    return serviceRoles.one('hep').one('all').get({
      type: 'RolesAndPrivileges',
      isDefaultRequired: true,
      filter: query
    }).then(function (hepData) {
      return hepData.hepList[0];
    });
  }
  function deleteRole(roleName) {
    var rsqlQuery = new RsqlQuery();
    var query = rsqlQuery.is('role').equalTo(roleName).query();
    return serviceRoles.one('hep').customDELETE('bulk', {
      type: 'RolesAndPrivileges',
      filter: query
    });
  }
  function getRoles() {
    return userRoles.one('roles').get().then(function (rolesData) {
      return _.map(rolesData.roles, function (d) {
        return (d.role || '').toLowerCase();
      });
    });
  }
  function throwWarning(roleName) {
    var errorMsg = 'Role ' + roleName + ' already exists';
    $log.error('NewRoleService: throwWarning - ' + errorMsg);
    toastr.error(errorMsg);
  }
  function isExistsRole(roleName) {
    var defer = $q.defer();
    if (!roleName) {
      throwWarning(roleName);
      return defer.reject();
    }
    getRoles().then(function (roleData) {
      if (_.includes(roleData, roleName.toLowerCase())) {
        throwWarning(roleName);
        return defer.reject();
      } else if (roleName.toLowerCase() === 'systemowner') {
        throwWarning(roleName);
        return defer.reject();
      }
      defer.resolve();
    });
    return defer.promise;
  }
  function saveRole(components, roleName, onlySave) {
    var rolePayload = {
      type: 'RolesAndPrivileges',
      hepKey: 'RolesAndPrivileges.' + roleName,
      attributes: {
        role: roleName
      },
      properties: {
        privileges: []
      }
    };
    _.transform(components, function (result, item) {
      var privilege = {
        component: item.component,
        category: item.category,
        privilege: null
      };
      if (item.isEditable) {
        privilege.privilege = 'WRITE';
      } else if (item.isViewable) {
        privilege.privilege = 'READ';
      } else {
        return;
      }
      if (item.component === 'user-management') {
        rolePayload.attributes.roleCategory = 'Admin';
      }
      result.push(privilege);
    }, rolePayload.properties.privileges);
    if (onlySave) {
      return serviceRoles.customPUT(rolePayload, 'hep', {
        upsert: true
      }).then(function () {
        toastr.success('Role ' + roleName + ' saved successfully');
      });
    } else {
      return deleteRole(roleName).then(function () {
        return serviceRoles.customPUT(rolePayload, 'hep', {
          upsert: true
        }).then(function () {
          toastr.success('Role ' + roleName + ' saved successfully');
        });
      });
    }
  }
  return {
    save: saveRole,
    isExistsRole: isExistsRole,
    getRole: getRole
  };
};
NewRoleService.$inject = ['Restangular', 'RsqlQueryFactory', '$q', '$log'];
module.exports = NewRoleService;